const useSessionStorage = (sessionStorageKey, locked, disableFields) => {
  const unpackValueFromStorage = (key) => {
    const storageKey = `${sessionStorageKey}:${key}`;
    const storedValue = sessionStorage.getItem(storageKey) || "";
    sessionStorage.removeItem(storageKey);
    return storedValue;
  };

  const storeFieldForReload = (key, value) => {
    if (locked && !disableFields) {
      const storageKey = `${sessionStorageKey}:${key}`;
      sessionStorage.setItem(storageKey, value);
    }
  };

  return [unpackValueFromStorage, storeFieldForReload];
};

export default useSessionStorage;
